import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8r6mpcfxv: FaireProductEntity = {
  token: "p_s8r6mpcfxv",
  type: "product",
  name: "Kids’ Sun Protection Baseball Cap - Outdoor Hat_CWAH2913",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/3317d252600623ecfbadde265cd4b0e035f2a2be95dc5c70000522b3be12b6d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0d3d0f87358033676804357b782217658d95c91c94b3b51505f409788736154.jpeg",
    "https://cdn.faire.com/fastly/f7365144d9e6a36a5bbe2e445067f64d143f0cee73d0463ba9a5a68e6360aef7.jpeg",
    "https://cdn.faire.com/fastly/4f0e350526f2cfad2ad7cc3167310a12093889737d4f028d20ac2ae30c3e8379.jpeg",
    "https://cdn.faire.com/fastly/857ba7719da40d3e30d86e5d752ed2a36d686ac9fd3aabaf803ac9248416eba5.jpeg",
    "https://cdn.faire.com/fastly/a895246eae1f2fdbb9400019a07e55ac91aee1ee7c885ad991559510060d41b3.jpeg",
    "https://cdn.faire.com/fastly/0bd7f70584a5de1075da5a1dce636025e69266041a98f4c18c479741ccc2891b.jpeg",
    "https://cdn.faire.com/fastly/fb926510ac2f895a3ac79ee8587d12054cac72acf12346151c903826a62b821a.jpeg",
    "https://cdn.faire.com/fastly/2e550314902a9c7c723ea146a2afaeb717c851235d1a418a372327afa5edad92.jpeg",
  ],
  priceDollars: 7.75,
  description:
    '-Brim Style: Curved Brim\n-Main Fabric Content: 100%\n-Fabric: Cotton\n-Size:\nHead Circumference: 19.7"-20.5" (50-52cm)\nTypes of products that will be on the shelves during this period: \nbaseball caps for women,baseball caps embroidered,baseball cap blanks,baseball cap rack,baseball cap patches,baseball caps custom,Baseball Cap,Dad Hat,Trucker Hat,Snapback Hat,Fitted Cap,Vintage Baseball Cap,Distressed Baseball Hat,Washed Cotton Cap,Retro Snapback Hat,Classic Baseball Cap,Cotton Baseball Cap,Denim Baseball Hat,Mesh Trucker Hat,Leather Baseball Cap,Corduroy Baseball Hat,Sports Baseball Cap,Outdoor Sun Hat,Golf Baseball Cap,Running Cap,Hiking Cap,Adjustable Baseball Cap,Breathable Mesh Cap,UV Protection Hat,Waterproof Baseball Cap,Lightweight Sports Cap,Custom Embroidered Baseball Cap,Eco-Friendly Cotton Baseball Hat.',
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:31.514Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
